import { ReactElement } from "react";
import { ICasterProduction } from "../../../../types";
import { TextField } from "@mui/material";
// import { IGaugeConfig } from "../../../../components/charts/types";
// import { getPalette } from "../../../../configuration/configuration";
// import GaugeChart from "../../../../components/charts/gaugeChart";

interface IProps {
  productionData: ICasterProduction[];
}


const ProductionHeader = ({ productionData }: IProps): ReactElement => {
  // let totalKwhTon = 0;
  // let totalKwh = 0;
  // let totalTapToTap = 0;
  // let minTapToTap = productionData[0].tapToTap / 60;
  // let maxTapToTap = productionData[0].tapToTap / 60;
  //
  // let totalWeight = 0;
  // let minWeight = toTons(productionData[0].weight);
  // let maxWeight = toTons(productionData[0].weight);
  //
  // let totalYield = 0;
  // let minYield = productionData[0].yield * 100;
  // let maxYield = productionData[0].yield * 100;

  const total = productionData.length;
  // let avgLastTemp = 0;
  // let minLastTemp = Number.MAX_VALUE;
  // let maxLastTemp = Number.MIN_VALUE;
  //
  // let avgLastO2PPM = 0;
  // let minLastO2PPM = Number.MAX_VALUE;
  // let maxLastO2PPM = Number.MIN_VALUE;
  //
  // productionData.forEach(heat => {
  //   avgLastTemp += heat.lastTemp ?? 0;
  //   minLastTemp = Math.min(minLastTemp, heat.lastTemp ?? Number.MAX_VALUE);
  //   maxLastTemp = Math.max(maxLastTemp, heat.lastTemp ?? Number.MIN_VALUE);
  //
  //   avgLastO2PPM += heat.lastO2PPM ?? 0;
  //   minLastO2PPM = Math.min(minLastO2PPM, heat.lastO2PPM ?? Number.MAX_VALUE);
  //   maxLastO2PPM = Math.max(maxLastO2PPM, heat.lastO2PPM ?? Number.MIN_VALUE);
  // });

  // totalKwhTon = productionData.length > 0 ? totalKwhTon / productionData.length : 0;
  // totalKwh = productionData.length > 0 ? totalKwh / productionData.length : 0;


  // const gaugeConfig: IGaugeConfig = {
  //   minimum: minLastTemp,
  //   maximum: maxLastTemp,
  //   start: 270,
  //   length: 180,
  //   segments: [
  //     { start: minLastTemp, end: maxLastTemp, color: getPalette().statusColor.empty.background },
  //   ],
  //   format: n => n.toFixed(2)
  // };
  //
  // const gaugeConfigO2PPM: IGaugeConfig = {
  //   minimum: minLastO2PPM,
  //   maximum: maxLastO2PPM,
  //   start: 270,
  //   length: 180,
  //   segments: [
  //     { start: minLastO2PPM, end: maxLastO2PPM, color: getPalette().statusColor.empty.background },
  //   ],
  //   format: n => n.toFixed(2)
  // };

  // const gaugeConfigWeight: IGaugeConfig = {
  //   minimum: minWeight,
  //   maximum: maxWeight,
  //   start: 270,
  //   length: 180,
  //   segments: [
  //     { start: minWeight, end: maxWeight, color: getPalette().statusColor.empty.background },
  //   ],
  //   format: n => n.toFixed(2)
  // };

  const keyBase = `${Date.now()}`;

  return (
    <div className="display-flex-row mt-1">
      <div className="flex-grow-0 display-flex-row flex-wrap" style={{ height: 100 }}>

        <TextField className="form-control"
          variant="standard"
          key={`${keyBase}-total-heats`}
           slotProps={{ input: { readOnly: true }}}
          label={"Total Heats"}
          defaultValue={total}/>

        {/*<TextField className={classes.formControl}*/}
        {/*  key={`${keyBase}-total-tap-to-tap`}*/}
        {/*  InputProps={{ readOnly: true }}*/}
        {/*  label={"Total Tap to Tap [min]"}*/}
        {/*  defaultValue={totalTapToTap.toFixed(2)}/>*/}

        {/*<TextField className={classes.formControl}*/}
        {/*  key={`${keyBase}-total-weight`}*/}
        {/*  InputProps={{ readOnly: true }}*/}
        {/*  label={"Total Weight [Ton]"}*/}
        {/*  defaultValue={toTons(totalWeight).toFixed(2)}/>*/}

        {/*<TextField className={classes.formControl}*/}
        {/*  key={`${keyBase}-average-kwh`}*/}
        {/*  InputProps={{ readOnly: true }}*/}
        {/*  label={"Average kwh"}*/}
        {/*  defaultValue={totalKwh.toFixed(2)}/>*/}

        {/*<TextField className={classes.formControl}*/}
        {/*  key={`${keyBase}-average-kwh-ton`}*/}
        {/*  InputProps={{ readOnly: true }}*/}
        {/*  label={"Average kwh / Ton"}*/}
        {/*  defaultValue={totalKwhTon.toFixed(2)}/>*/}

      </div>

      {/*{productionData.length &&*/}
      {/*  <div className="display-flex-row flex-grow-0 align-content-center" style={{ width: 200 }}>*/}
      {/*    <GaugeChart gaugeConfig={gaugeConfig} value={avgLastTemp / productionData.length} keyValue="Last Temp [°C]"/>*/}
      {/*    <GaugeChart  gaugeConfig={gaugeConfigO2PPM} value={avgLastO2PPM / productionData.length} keyValue="Last O2 PPM" />*/}
      {/*    /!*<GaugeChart  gaugeConfig={gaugeConfigWeight} value={toTons(totalWeight) / productionData.length} keyValue="Weight [Ton]" />*!/*/}
      {/*  </div>*/}
      {/*}*/}
    </div>
  );
};

export default ProductionHeader;
